import { render } from "./InlineEditTable.vue?vue&type=template&id=10b4d6a6&scoped=true"
import script from "./InlineEditTable.vue?vue&type=script&lang=ts"
export * from "./InlineEditTable.vue?vue&type=script&lang=ts"

import "./InlineEditTable.vue?vue&type=style&index=0&id=10b4d6a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10b4d6a6"

export default script